<template>
  <div class="assets">
    <div class="title">资产管理</div>
    <div class="content">
      <div class="drawcash">
        <span class="money">
          余额：<strong style="color: #333333; font-size: 18px">¥</strong
          ><strong class="balance">{{ assets.property || 0 }}</strong></span
        >
        <a-button class="draw-btn" type="primary" @click="goWithdraw">提现</a-button>
        <span class="rules" @click="openRule">提现规则</span>
      </div>
      <a-tabs type="card" @change="tabChange" v-model="tabIndex">
        <a-tab-pane key="1" tab="收入明细">
          <a-table
            :columns="columns"
            :row-key="(record) => record.id"
            :data-source="salesList.list"
            :pagination="salesPagination"
            :loading="loading"
            :locale="{
              emptyText: `${$moment(salesList.queryparams.month).format('MM')}月暂无销售记录，去看看其他月份的吧`,
            }"
            @change="handleSaleTableChange"
          >
            <template slot="package_name">
              素材集名称
              <a-tooltip>
                <template slot="title">
                  <span>
                    为提升分发销售效率，平台会以主题、分类等为依据，将您上传的若干个素材包打包成“大礼包”的形式，进行分发销售</span
                  >
                </template>
                <a-button type="link" style="padding: 0 8px"><a-icon type="question-circle" /></a-button>
              </a-tooltip>
            </template>

            <template slot="gmt_create_title">
              <a-month-picker
                :default-value="$moment()"
                :allowClear="false"
                :disabledDate="disabledPayDate"
                format="YYYY年MM月"
                style="width: 100%; color: #ff7401; width: 120px; cursor: pointer"
                class="datePick"
                @change="handleSaleApplyDateChange"
                @ok="handleSaleApplyDateChange"
              >
                <span
                  slot="suffixIcon"
                  style="color: #ff7401; font-size: 10px; margin-top: -5px"
                  class="icon-icon_unfold"
                ></span>
              </a-month-picker>
            </template>
            <!-- <template slot="package_list" slot-scope="text,record">
              <a-tooltip @visibleChange="visibleChange($event,record)">
                <template slot="title">
                  <div class="package_info_box">
                    <div class="package-item" v-for="(item,index) in packageList" :key="index">
                      {{ index+1 }}.{{ item.package_title }}
                    </div>
                  </div>

                </template>
                <span class="materialDetail">素材详情</span>
              </a-tooltip>
            </template> -->
          </a-table>
          <!-- <div class="ant-table-placeholder">服务器系统升级中，升级期间部分页面和功能暂停服务（余额和提现功能正常开放），升级后将重新提供服务。</div> -->
        </a-tab-pane>
        <a-tab-pane key="2" tab="提现记录">
          <a-table
            :columns="drawColumns"
            :row-key="(record) => record.id"
            :data-source="drawList.list"
            :pagination="drawPagination"
            :loading="loading"
            :locale="{
              emptyText: `暂无提现记录`,
            }"
            @change="handleDrawTableChange"
          >
            <template slot="statusTxs" slot-scope="text, record">
              <span
                class="status_wrapper"
                :class="{
                  'error-text': record.payment_status == '2',
                  'success-text': record.payment_status == '1',
                  'process-text': record.payment_status == '0',
                }"
              >
                {{ record.statusTxs }}
                <a-tooltip v-if="record.payment_status == '2'" class="status_icon">
                  <template slot="title">
                    {{ record.payment_error }}
                  </template>
                  <template>
                    <span class="icon-left_help_16 errorIcon font_family"></span>
                  </template>
                </a-tooltip>
              </span>
            </template>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="3" tab="数据中心">
          <div v-if="openDatacenter">
            <p class="tips">
              <span style="color: #f5222d">*</span>2021年1月4日起新增当前页面数据，历史日期无此项数据。每日0时更新。
            </p>
            <div class="card-list">
              <div class="card-item">
                <div class="name">总销售量</div>
                <div class="num">{{ dataCenter.history_sale_count || 0 }}</div>
                <div class="increment">
                  <span>日</span><span class="icon-icon_shangsheng_12"></span>
                  <span>+{{ dataCenter.yesterday_sale_count || 0 }}</span>
                </div>
              </div>
              <div class="card-item">
                <div class="name">总分成额</div>
                <div class="num">{{ dataCenter.history_sale_money || 0 }}</div>
                <div class="increment">
                  <span>日</span><span class="icon-icon_shangsheng_12"></span>
                  <span>+{{ dataCenter.yesterday_sale_money || 0 }}</span>
                </div>
              </div>
            </div>

            <div style="display: flex; justify-content: space-between">
              <div class="content-title">销售趋势图</div>
              <div style="height: 30px; width: 140px; font-size: 14px; color: #666666; margin-right: 14px">
                <a-month-picker
                  :default-value="$moment()"
                  :allowClear="false"
                  :disabledDate="disabledPayDate2"
                  format="YYYY年MM月"
                  style="width: 100%"
                  class="datePick2"
                  @change="handleApplyDateChange"
                  @ok="handleApplyDateChange"
                >
                  <span slot="suffixIcon" style="color: #999999; font-size: 14px" class="icon-icon_calendar_16"></span>
                </a-month-picker>
              </div>
            </div>

            <div class="charts-area" id="echart-main"></div>
          </div>
          <div v-else style="width: 100%; height: 400px; display: flex; justify-content: center; align-items: center">
            <span class="tips">暂未开放</span>
          </div>
        </a-tab-pane>
        <a-tab-pane key="4" tab="素材明细">
          <div v-if="openDatacenter">
            <div class="tips">
              <span style="color: #f5222d">*</span>2021年1月4日起新增当前页面数据，历史日期无此项数据。每日0时更新。
              <a-button style="margin-left: 30px;" icon="export" @click="exportTable">导出表格</a-button>
            </div>
            <a-table
              :columns="materialColumns"
              :row-key="(record) => record.id"
              :data-source="materialList.list"
              :pagination="materialList.materialPagination"
              :loading="loading"
              :locale="{
                emptyText: `${$moment(activeDateMaterial).format('MM月')}暂无记录，去看看其他月份的吧`,
              }"
              @change="handleMaterialTableChange"
            >
              <template slot="gmt_create_title">
                <a-month-picker
                  :default-value="$moment()"
                  :allowClear="false"
                  :disabledDate="disabledPayDate2"
                  format="YYYY年MM月"
                  style="width: 100%; color: #ff7401; width: 120px"
                  class="datePick"
                  @change="handleMaterialApplyDateChange"
                  @ok="handleMaterialApplyDateChange"
                >
                  <span
                    slot="suffixIcon"
                    style="color: #ff7401; font-size: 10px; margin-top: -5px"
                    class="icon-icon_unfold"
                  ></span>
                </a-month-picker>
              </template>
            </a-table>
          </div>
          <div v-else style="width: 100%; height: 400px; display: flex; justify-content: center; align-items: center">
            <span class="tips">暂未开放</span>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
    <a-modal class="drawRule-modal" v-model="showRules" :destroy-on-close="true" :footer="null" width="760px" centered>
      <span class="close-modal-icon" slot="closeIcon"></span>
      <div class="title" slot="title">提现规则</div>
      <div style="padding: 0 20px">
        <p>1.提现规则：</p>
        <p>结算方式：采用月结的方式；</p>
        <p>提现时间：提现申请时间为每个月的1日-10日；</p>
        <p>
          提现次数：每月只能提现1次（提现次数按成功次数计算，例如，提现失败的话，可以发出提现申请，直到当月成功为止，但需要在规定时间内申请】
          提现额度限制：每笔提现金额不得低于100元。
        </p>
        <p style="margin-top: 20px">2.扣税规则：</p>
        <p>M Art将根据国家相关法律法规代扣代缴相关税费(如有)，直接发放扣缴后的净额部分</p>
        <p>应纳税所得额 = 提现金额（少于4000元） - 800元</p>
        <p>应纳税所得额 = 提现金额（超过4000元） × （1 - 20%）</p>
        <p>应纳税额 = 应纳税所得额 × 适用税率 - 速算扣除数</p>
        <p style="margin-top: 20px">说明：</p>
        <p>1、提现金额所得在800元以下的，不用缴纳个人所得税;</p>
        <p>2、提现金额所得大于800元且没有超过4000元，可减除800元的扣除费用;</p>
        <p>3、提现金额所得超过4000元的，可减除劳务报酬收入20%的扣除费用;</p>
        <div style="margin-top: 20px">
          <p>劳务报酬个人所得税税率表</p>
          <a-table
            :pagination="false"
            :row-key="(record) => record.level"
            :columns="[
              {
                title: '级数',
                dataIndex: 'level',
                align: 'center',
              },
              {
                title: '应纳税收入额(含税)',
                dataIndex: 'tax',
                align: 'center',
              },
              {
                title: '应纳税收入额(不含税)',
                dataIndex: 'notax',
                align: 'center',
              },
              {
                title: '税率(%)',
                dataIndex: 'rate',
                align: 'center',
              },
              {
                title: '速算扣除数',
                dataIndex: 'money',
                align: 'center',
              },
            ]"
            :data-source="[
              {
                level: '1',
                tax: '不超过20,000',
                notax: '不超过16,000',
                rate: '20%',
                money: '0',
              },
              {
                level: '2',
                tax: '超过20,000元至50,000元的部分',
                notax: '超过16,000元至37,000元的部分',
                rate: '30%',
                money: '2,000',
              },
              { level: '3', tax: '超过50,000', notax: '超过37,000 ', rate: '40%', money: '7000' },
            ]"
          >
          </a-table>
        </div>
      </div>

      <a-button
        type="primary"
        @click="showRules = false"
        class="submit-button"
        style="width: 330px; height: 50px; border-radius: 8px"
      >
        确定
      </a-button>
    </a-modal>
    <a-modal class="tips-modal" v-model="showTips" :destroy-on-close="true" :footer="null" width="760px" centered>
      <span class="close-modal-icon" slot="closeIcon"></span>
      <div class="tipsContent">
        为给您提供更便捷的提现服务，M Art提现方式已全面升级为支付宝转账，请您前往修改绑定，谢谢！
      </div>
      <div class="btn-list">
        <a-button type="default" @click="showTips = false" class="cancel-button"> 稍后修改 </a-button>
        <a-button type="primary" @click="goBindAlipay" class="submit-button"> 去绑定支付宝 </a-button>
      </div>
    </a-modal>
    <a-modal class="userTips-modal" v-model="showUserTips" :footer="null" width="760px" centered>
      <span class="close-modal-icon" slot="closeIcon"></span>
      <div class="tipsContent" v-if="userInfo.authentication_status != 2">
        {{ userInfo.authentication_status !== '' && tipsText[userInfo.authentication_status].text }}
      </div>
      <div class="btn-list" v-if="userInfo.authentication_status != 2">
        <a-button type="primary" @click="goAuthentication" class="submit-button">
          {{ userInfo.authentication_status !== '' && tipsText[userInfo.authentication_status].btn }}
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
// 引入 ECharts 主模块
import { timeFormat } from '@/utils/util.js'
var echarts = require('echarts')

export default {
  name: 'Assets',
  data () {
    return {
      tipsText: {
        0: {
          text: '通过画师认证才可以绑定支付宝哦，先去认证吧~',
          btn: '去认证'
        },
        1: {
          text: '您的画师认证审核中，请耐心稍等，通过画师认证才可以绑定支付宝哦',
          btn: '确定'
        },
        3: {
          text: '您的画师认证未通过，请修改并重新提交认证，通过画师认证才可以绑定支付宝哦',
          btn: '去认证'
        }
      },
      showUserTips: false,
      // showUnauthorizedTips: false,
      // showAuditTips: false,
      // UnapproveTips: false,
      showTips: false,
      tabIndex: '1',
      overlayStyle: {
        width: '104px',
        height: '248px',
        overflow: 'auto',
        fontSize: '14px',
        color: '#666666',
        boxSizing: 'border-box',
        backgroundColor: '#fff'
      },
      overlayStyle1: {
        width: '126px',
        height: '188px',
        overflow: 'auto',
        fontSize: '14px',
        color: '#666666',
        boxSizing: 'border-box',
        backgroundColor: '#fff'
      },
      columns: [
        {
          dataIndex: 'date',
          scopedSlots: { title: 'gmt_create_title' },
          customRender: record => this.$moment.unix(record).format('MM/DD'),
          align: 'center'
        },
        {
          title: '日收入（元）',
          dataIndex: 'day_income',
          align: 'center'
        }
      ],
      materialColumns: [
        {
          dataIndex: 'gmt_create',
          scopedSlots: { title: 'gmt_create_title' },
          customRender: record => this.$moment.unix(record).format('DD日'),
          align: 'center'
        },
        {
          title: '素材名称',
          dataIndex: 'package_name',
          align: 'center'
        },
        {
          title: '素材类型',
          dataIndex: 'package_status',
          align: 'center'
        },
        {
          title: '当日销售量',
          dataIndex: 'sales_count',
          align: 'center'
        },
        {
          title: '当日销售额',
          dataIndex: 'sales_day',
          align: 'center',
          customRender: record => `￥${record}`
        },
        {
          title: '当月销售额',
          dataIndex: 'sales_month',
          align: 'center',
          customRender: record => `￥${record}`
        },
        {
          title: '历史销售额',
          dataIndex: 'sales_history',
          align: 'center',
          customRender: record => `￥${record}`
        },
        {
          title: '当日分成',
          dataIndex: 'money_day',
          align: 'center',
          customRender: record => `￥${record}`
        },
        {
          title: '当月分成',
          dataIndex: 'money_month',
          align: 'center',
          customRender: record => `￥${record}`
        },
        {
          title: '历史分成',
          dataIndex: 'money_history',
          align: 'center',
          customRender: record => `￥${record}`
        }
      ],
      drawColumns: [
        {
          title: '提现时间 ',
          dataIndex: 'gmt_create',
          width: '20%',
          align: 'center',
          customRender: record => this.$moment.unix(record).format('YYYY/MM/DD')
        },
        {
          title: '提现金额 ',
          dataIndex: 'money',
          width: '20%',
          align: 'center'
        },
        {
          title: '扣税金额',
          dataIndex: 'tax_money',
          align: 'center'
        },
        {
          title: '到账金额',
          dataIndex: 'real_money',
          align: 'center'
        },
        {
          title: '提现状态',
          dataIndex: 'statusTxs',
          scopedSlots: { customRender: 'statusTxs' },
          align: 'center'
        }],
      loading: false,
      salesPagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        defaultCurrent: 1,
        current: 1
      },
      drawPagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      showRules: false,
      drawList: {
        list: [],
        queryparams: {
          page: 1,
          pagesize: 10

        }
      },
      salesList: {
        list: [],
        queryparams: {
          page: 1,
          pagesize: 10,
          month: this.$moment().format('YYYY-MM')
        }
      },
      materialList: {
        list: [],
        queryparams: {
          page: 1,
          pagesize: 10,
          time: this.$moment().format('YYYY-MM-DD')
        },
        materialPagination: {
          page: 1,
          pageSize: 10,
          total: 0,
          defaultCurrent: 1,
          current: 1
        }
      },
      assets: {},
      packageList: [],
      activeDate: this.$moment().format('YYYY-MM'),
      dateList: [],
      dataCenter: {},
      activeDateMaterial: this.$moment().format('YYYY-MM'),
      openDatacenter: true
    }
  },
  components: {

  },
  computed: {
    userInfo () {
      return this.$store.state.user.info
    }
  },
  created () {
    if (this.$route.query.active && this.$route.query.active === 'withdraw') {
      this.tabIndex = '2'
    }
    if (this.tabIndex === '1') {
      this.loadSalesData()
    } else if (this.tabIndex === '2') {
      this.loadWithDrawData()
    }

    this.getUserAssets()
  },
  mounted () {
    // this.initDate()
  },
  methods: {
    goAuthentication () {
      if (this.userInfo.authentication_status != '1') {
        this.$router.push({
          path: '/manage/userAuthentication'
        })
      }
      this.showUserTips = false
    },
    disabledPayDate (current) {
      return current && current < this.$moment('2020-06')
    },
    disabledPayDate2 (current) {
      return current && current < this.$moment('2021')
    },
    handleApplyDateChange (dates) {
      this.activeDate = dates.format('YYYY-MM')
      this.loadDataTrend()
    },
    handleMaterialApplyDateChange (dates) {
      this.activeDateMaterial = dates.format('YYYY-MM')
      this.materialList.queryparams.page = 1

      this.loadMaterialCenter()
    },
    handleSaleApplyDateChange (dates) {
      this.salesList.queryparams.month = dates.format('YYYY-MM')
      this.salesList.queryparams.page = 1

      this.loadSalesData()
    },
    timeFormat,
    // 获取销售流水
    loadSalesData () {
      this.loading = true
      const { page, pagesize } = this.salesList.queryparams
      const params = Object.assign({ page, pagesize }, { time: this.salesList.queryparams.month })
      this.$api.assets.getSaleFlowList(params).then(res => {
        if (res.status === 'ok') {
          this.salesList.list = res.data.list
          this.salesPagination.total = res.data.list.length
          this.salesPagination.current = page
          this.loading = false
        } else {

        }
      })
    },
    loadWithDrawData () {
      this.loading = true
      const params = Object.assign({ ...this.drawList.queryparams }, {})
      this.$api.assets.getDrawRecordList(params).then(res => {
        if (res.status === 'ok') {
          this.drawList.list = res.data.list
          this.drawPagination.total = res.data.count
          this.loading = false
        } else {

        }
      })
    },
    loadMaterialCenter () {
      const params = Object.assign({ ...this.materialList.queryparams }, { time: this.$moment(this.activeDateMaterial).format('YYYY-MM-DD') })
      this.$api.assets.getMaterialCenter(params).then(res => {
        if (res.status === 'ok') {
          this.materialList.list = res.data.list
          this.materialList.materialPagination.total = res.data.count
          this.materialList.materialPagination.current = params.page
          this.loading = false
        } else {

        }
      })
    },
    // 获取余额
    getUserAssets () {
      this.$api.assets.getUserAssets().then(res => {
        if (res.status === 'ok') {
          this.assets = res.data
        } else {

        }
      })
    },
    tabChange (e) {
      this.tabIndex = e
      // demo 环境不用屏蔽
      const lastDate = window.location.host.indexOf('web-all.mindcomic.com') > -1 ? '2020-01-04' : '2021-01-04'
      if (e == 1) {
        this.loadSalesData()
      } else if (e == 2) {
        this.loadWithDrawData()
      } else if (e == 3) {
        if (this.$moment().isBefore(lastDate)) {
          this.openDatacenter = false
          this.$message.warning('2021年1月4日才开放哦！')
        } else {
          this.loadDataCenter()
          this.loadDataTrend()
        }
      } else if (e == 4) {
        if (this.$moment().isBefore(lastDate)) {
          this.openDatacenter = false
          this.$message.warning('2021年1月4日才开放哦！')
        } else {
          this.loadMaterialCenter()
        }
      }
    },
    goWithdraw () {
      // 先判断是否通过画师认证
      if (this.userInfo.authentication_status != '2') {
        this.showUserTips = true
      } else {
        if (this.assets.status === true) {
          if (this.userInfo.alipay_account && this.userInfo.alipay_account !== '') { // 已经绑定支付宝
            this.$router.push({
              path: '/manageUser/withdraw'
            })
          } else {
            if (this.assets.bank_status === true) { // 已经绑定银行卡
              this.showTips = true
            } else { // 没绑定银行卡也没绑定支付宝
              this.$router.push('/manageUser/bindAliPay?back=withdraw')
            }
          }
        } else if (this.assets.status === '2') {
          this.$message.error(this.assets.reason)
          this.tabIndex = '2'
          this.loadWithDrawData()
        } else {
          this.$message.error(this.assets.reason)
        }
      }
    },
    handleSaleTableChange (pagination, filters, sorte) {
      const { pageSize, current } = pagination
      this.salesList.queryparams.page = current
      this.salesList.queryparams.pagesize = pageSize

      this.loadSalesData()
    },
    handleDrawTableChange (pagination, filters, sorte) {
      const { pageSize, current } = pagination
      this.drawList.queryparams.page = current
      this.drawList.queryparams.pagesize = pageSize
      this.loadWithDrawData()
    },
    handleMaterialTableChange (pagination, filters, sorte) {
      const { pageSize, current } = pagination
      this.materialList.queryparams.page = current
      this.materialList.queryparams.pagesize = pageSize

      this.loadMaterialCenter()
    },
    selectMonth ({ key }) {
      this.salesList.queryparams.month = key
      this.loadSalesData()
    },
    openRule () {
      this.showRules = true
    },
    goBindAlipay () {
      this.$router.push({
        path: '/manageUser/bindAliPay?back=withdraw'
      })
    },
    visibleChange (visible, record) {
      console.log(visible, record)
      if (visible) {
        this.$api.texture.getTextureInfo({ id: record.package_id }).then(res => {
          if (res.status === 'ok') {
            this.packageList = res.data
          }
        })
      }
    },
    initDate () {
      const year = this.$moment().year()
      let now = this.$moment().month() + 1
      if (now < 10) now = '0' + now
      this.activeDate = `${year}-${now}`
      this.activeDateMaterial = `${year}-${now}`
      for (let i = 1; i <= now; i++) {
        if (i < 10) i = '0' + i
        this.dateList.push(`${year}-${i}`)
      }
      console.log(now, year)
    },
    handleMenuClick (e) {
      this.activeDate = e.key
      this.loadDataTrend()
    },
    selectMonthMaterial (e) {
      this.activeDateMaterial = e.key
      this.loadMaterialCenter()
    },
    loadDataCenter () {
      this.loading = true

      this.$api.assets.getDataCenter().then(res => {
        if (res.status === 'ok') {
          this.dataCenter = res.data
          this.loading = false
        }
      })
    },
    loadDataTrend () {
      const params = { date: this.activeDate }
      this.$api.assets.getDataTrend(params).then(res => {
        if (res.status === 'ok') {
          const data_x = res.data.list.map(item => item.date_x)
          const data_sale_money_y = res.data.list.map(item => item.sale_money_y)
          const data_sale_num_y = res.data.list.map(item => item.sale_num_y)
          this.$nextTick(() => {
            // 基于准备好的dom，初始化echarts实例
            var myChart = echarts.init(document.getElementById('echart-main'))
            const option = {
              title: {
                text: ''
              },
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'cross',
                  label: {
                    backgroundColor: '#6a7985'
                  }
                }
              },
              legend: {
                itemWidth: 16,
                itemGap: 40,
                bottom: '0%',
                textStyle: {
                  fontSize: 14
                },
                data: [
                  {
                    name: '销售数量',
                    icon: 'path://M960 576H620.8c12.8-19.2 19.2-38.4 19.2-64s-6.4-44.8-19.2-64H960c38.4 0 64 25.6 64 64s-25.6 64-64 64zM403.2 576H64c-38.4 0-64-25.6-64-64s25.6-64 64-64h339.2c-12.8 19.2-19.2 38.4-19.2 64s6.4 44.8 19.2 64z M512 768c-140.8 0-256-115.2-256-256s115.2-256 256-256 256 115.2 256 256-115.2 256-256 256z m0-384c-70.4 0-128 57.6-128 128s57.6 128 128 128 128-57.6 128-128-57.6-128-128-128z'
                  },
                  {
                    name: '每日分成额',
                    icon: 'path://M960 576H620.8c12.8-19.2 19.2-38.4 19.2-64s-6.4-44.8-19.2-64H960c38.4 0 64 25.6 64 64s-25.6 64-64 64zM403.2 576H64c-38.4 0-64-25.6-64-64s25.6-64 64-64h339.2c-12.8 19.2-19.2 38.4-19.2 64s6.4 44.8 19.2 64z M512 768c-140.8 0-256-115.2-256-256s115.2-256 256-256 256 115.2 256 256-115.2 256-256 256z m0-384c-70.4 0-128 57.6-128 128s57.6 128 128 128 128-57.6 128-128-57.6-128-128-128z'
                  }
                ]

              },
              toolbox: {
              },
              grid: {
                left: '2%',
                right: '3%',
                bottom: '60',
                top: '40px',
                containLabel: true
              },
              xAxis: [
                {
                  type: 'category',
                  boundaryGap: false,
                  data: data_x,
                  axisLine: {
                    lineStyle: {
                      color: ['#ccc'],
                      type: 'dashed'
                    }
                  },
                  axisLabel: {
                    color: '#333333'
                  },
                  splitLine: {
                    show: true,
                    lineStyle: {
                      color: ['#ccc'],
                      width: 1,
                      type: 'dashed'
                    }
                  }
                }
              ],
              yAxis: [
                {
                  type: 'value',
                  axisLine: {
                    lineStyle: {
                      color: ['#ccc'],
                      type: 'dashed'
                    }
                  },
                  axisLabel: {
                    color: '#333333'
                  },
                  splitLine: {
                    show: true,
                    lineStyle: {
                      color: ['#ccc'],
                      width: 1,
                      type: 'dashed'
                    }
                  }
                }
              ],
              series: [
                {
                  name: '销售数量',
                  type: 'line',
                  symbolSize: 7,
                  areaStyle: {
                    color: '#5D9CEC',
                    opacity: 0.2
                  },
                  itemStyle: {
                    color: '#5D9CEC'
                  },
                  data: data_sale_num_y
                },
                {
                  name: '每日分成额',
                  type: 'line',

                  symbolSize: 7,
                  areaStyle: {
                    color: '#6CAD4C',
                    opacity: 0.2
                  },
                  itemStyle: {
                    color: '#6CAD4C'
                  },
                  data: data_sale_money_y
                }
              ]
            }
            // 绘制图表
            myChart.setOption(option)
          })
        }
      })
    },
    exportTable () {
      const params = Object.assign({ ...this.materialList.queryparams }, { time: this.$moment(this.activeDateMaterial).format('YYYY-MM-DD') });
      this.$api.assets.getExportEverydayStatistics(params).then(res => {
        if (res.status === 'ok') {
          const data = res.data || {};
          if (data.url) {
            const link = document.createElement('a');
            const href = data.url;
            const path = href.split('?')[0];
            const name = path.split('/').pop();
            link.href = href;
            link.download = name;
            link.click();
          }
          this.loading = false
        } else {

        }
      })



    }
  }
}
</script>

<style lang="less" scoped>
.status_wrapper {
  position: relative;
  .status_icon {
    position: absolute;
    right: -22px;
    top: -2px;
  }
}
.errorIcon {
  color: #f5222d;
  width: 16px;
  height: 16px;
  margin-left: 10px;
  cursor: pointer;
}
/deep/ .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
  color: #999999;
}
/deep/ .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
  color: #ff7401;
}
.datePick2 {
  /deep/ .ant-input {
    cursor: pointer;
  }
}
.datePick {
  /deep/ .ant-input {
    border: none;
    background-color: #fafafa;
    color: #ff7401;
    cursor: pointer;
  }
  /deep/ .ant-input:focus {
    border-color: #fafafa;
  }
  /deep/ .ant-calendar-picker-input:focus {
    border-color: #fafafa;
  }
  .ant-calendar-picker:hover .ant-calendar-picker-input:not(.ant-input-disabled) {
    border: none;
  }
}
.package_info_box {
  max-height: 270px;
  overflow: auto;
}
/deep/ .ant-table-content {
  border-top: 1px solid rgba(242, 242, 242, 1);
  border-right: 1px solid rgba(242, 242, 242, 1);
  border-left: 1px solid rgba(242, 242, 242, 1);
}
.assets {
  background-color: #ffffff;
  min-height: 800px;
  /deep/ .ant-table-pagination.ant-pagination {
    margin: 32px 0;
  }
  /deep/ .ant-tabs-bar {
    margin-bottom: 30px;
  }
  /deep/ .ant-table-tbody {
    .ant-table-row:nth-last-of-type(2n + 1) {
      background-color: #f5f6f7;
    }
  }

  .materialDetail {
    color: #5b90b5;
    cursor: pointer;
    &:hover {
      color: @primary-color;
    }
  }
  .package-name {
    color: #5b90b5;
    cursor: pointer;
    &:hover {
      color: @primary-color;
    }
  }
  .title {
    color: @primary-color;
    font-size: 14px;
    padding: 17px 0 17px 24px;
    border-bottom: 1px solid #f2f2f2;
  }
  .content {
    padding: 36px;
    .drawcash {
      display: flex;
      align-items: center;
      margin-bottom: 40px;
      .money {
        font-size: 16px;
        color: #999999;
        .balance {
          font-size: 36px;
          color: #333333;
          margin-right: 20px;
          line-height: 36px;
        }
      }
      .draw-btn {
        width: 60px;
        height: 28px;
        font-size: 12px;
      }
      .rules {
        margin-left: 15px;
        text-decoration: underline;
        font-size: 12px;
        color: #999999;
        cursor: pointer;
        &:hover {
          color: @primary-color;
        }
      }
    }
    /deep/ .ant-tabs-nav .ant-tabs-tab {
      transition: none;
    }
    /deep/ .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
      background: none;
      margin-right: 0px;
      border: none;
    }
    /deep/ .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
      border: 1px solid #f2f2f2;
      border-radius: 8px 8px 0px 0px;
      border-bottom: 1px solid #fff;
    }
    /deep/ .ant-table-thead th {
      border-bottom: 2px solid @primary-color;
    }
    /deep/ .ant-table-placeholder {
      border-top: none;
      min-height: 600px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      color: #999999;
    }
    .tips {
      margin: 0px 0 32px;
      font-size: 12px;
      color: #999999;
    }
    .card-list {
      display: flex;
      margin-bottom: 45px;
      .card-item {
        padding: 24px;
        width: 280px;
        border: 1px solid #f2f2f2;
        box-sizing: border-box;
        margin-right: 24px;
        .name {
          color: #666666;
          font-size: 14px;
          line-height: 1;
          margin-bottom: 16px;
        }
        .num {
          line-height: 1;
          font-size: 32px;
          color: #333333;
          font-weight: bold;
          margin-bottom: 12px;
        }
        .increment {
          font-size: 12px;
          line-height: 1;
          span {
            font-size: 12px;
            color: #666666;
          }
          .icon-icon_shangsheng_12 {
            color: #f5222d;
            margin-left: 8px;
          }
          .icon-icon_xiajiang_12 {
            color: #6cae4c;
            margin-left: 8px;
          }
        }
      }
    }
    .content-title {
      position: relative;
      color: #333333;
      font-size: 16px;
      padding-left: 10px;
      line-height: 30px;
      &::before {
        content: '';
        display: block;
        width: 3px;
        height: 12px;
        border-radius: 32%;
        background-color: #ff7401;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    }
    .charts-area {
      width: 100%;
      height: 400px;
    }
  }
}
.drawRule-modal {
  .title {
    color: @primary-color;
    text-align: center;
    font-size: 24px;
  }
  .submit-button {
    display: block;
    text-align: center;
    margin: 40px auto 16px;
  }
}
.tips-modal {
  .tipsContent {
    font-size: 18px;
    padding: 56px 20px 36px;
    line-height: 30px;
    color: #333333;
  }
  .btn-list {
    display: flex;
    justify-content: center;
    .cancel-button {
      width: 200px;
      height: 50px;
      border-radius: 8px;
      margin-right: 20px;
    }
    .submit-button {
      width: 200px;
      height: 50px;
      border-radius: 8px;
    }
  }
}
.userTips-modal {
  .tipsContent {
    margin-bottom: 60px;
    text-align: center;
    margin-top: 63px;
    font-size: 18px;
    color: #333333;
  }
  .btn-list {
    display: flex;
    justify-content: center;
  }
  .submit-button {
    width: 200px;
    height: 50px;
    background: rgba(255, 116, 1, 1);
    border-radius: 8px;
  }
}
</style>
